<h2 mat-dialog-title class="dialog-title">Indikator bearbeiten</h2>

<mat-dialog-content class="mat-typography dialog-content">
  <form [formGroup]="frmIndicator">
    <!-- Hidden fields -->
    <div class="form-group">
      <input type="hidden" formControlName="room_id" [value]="roomId" />
      <input type="hidden" formControlName="standort_id" [value]="standortId" />
    </div>

    <!-- Indikator Type -->
    <div class="form-group">
      <label class="form-label" for="indikator_id">CODE/SYSTEMTYP *</label>
      <select class="form-control" id="indikator_id" formControlName="indikator_id" required [disabled]="loading">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let indikator of indikatoren" [value]="indikator.id">
          {{ indikator.code }} - {{ indikator.beschreibung }} ({{ indikator.einheit || 'keine Einheit' }})
        </option>
      </select>
      <div *ngIf="loading" class="text-sm text-gray-500 mt-1">Lade Indikatoren...</div>
    </div>

    <!-- Name -->
    <div class="form-group">
      <label class="form-label" for="name">Position *</label>
      <input type="text" class="form-control" id="name" formControlName="name" 
             placeholder="Position eingeben" required />
    </div>

    <!-- Indikator Number -->
    <div class="form-group">
      <label class="form-label" for="indikator_number">Indikator Nummer</label>
      <input type="text" class="form-control" id="indikator_number" formControlName="indikator_number" 
             placeholder="Wird automatisch vergeben" readonly style="background-color: #f8f9fa; color: #6c757d;" />
      <small class="form-text text-muted">Diese Nummer wird automatisch vergeben und kann nicht geändert werden.</small>
    </div>

    <!-- Unit -->
    <div class="form-group">
      <label class="form-label" for="einheit">Einheit *</label>
      <input type="text" class="form-control" id="einheit" formControlName="einheit" 
             placeholder="z.B. °C, %, lux, kWh" required />
    </div>

    <!-- Threshold Value -->
    <div class="form-group">
      <label class="form-label" for="schwellenwert">Schwellenwert *</label>
      <input type="text" class="form-control" id="schwellenwert" formControlName="schwellenwert" 
             placeholder="Schwellenwert eingeben" required />
    </div>



    <!-- Notes -->
    <div class="form-group">
      <label class="form-label" for="bemerkung">Bemerkung</label>
      <textarea class="form-control" id="bemerkung" formControlName="bemerkung" 
                placeholder="Zusätzliche Notizen" rows="3"></textarea>
    </div>



    <!-- Status -->
    <div class="form-group">
      <label class="form-label" for="status">Status</label>
      <select class="form-control" id="status" formControlName="status" required>
        <option value="">Bitte wählen...</option>
        <option [value]="1">Aktiv</option>
        <option [value]="0">Inaktiv</option>
      </select>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()" [disabled]="loading">
    Abbrechen
  </button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial [disabled]="loading || !frmIndicator.valid">
    <mat-icon *ngIf="loading" class="mr-2 animate-spin">hourglass_empty</mat-icon>
    <span *ngIf="!loading">Speichern</span>
  </button>
</mat-dialog-actions>
